// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__YagZG{
    padding:0px !important;
}
.styles_loaderHeight__gYy-x{
    height:100px;
}
.styles_infiniteContainer__0OlwS{
    
}
.styles_loader__hgg7Z{
    height:100%;
    width:100%;
}
.styles_loader__hgg7Z span{
    width: 50px;
    height: 50px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Searchpart/styles.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;;AAEA;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container{\n    padding:0px !important;\n}\n.loaderHeight{\n    height:100px;\n}\n.infiniteContainer{\n    \n}\n.loader{\n    height:100%;\n    width:100%;\n}\n.loader span{\n    width: 50px;\n    height: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__YagZG`,
	"loaderHeight": `styles_loaderHeight__gYy-x`,
	"infiniteContainer": `styles_infiniteContainer__0OlwS`,
	"loader": `styles_loader__hgg7Z`
};
export default ___CSS_LOADER_EXPORT___;
